import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faInstagram,
  faFacebook,
  faTiktok,
} from "@fortawesome/free-brands-svg-icons";
import {
  faCalendarAlt,
  faChartLine,
  faImage,
} from "@fortawesome/free-solid-svg-icons";

const SocialMediaPage = () => {
  return (
    <div className="max-w-6xl mx-auto p-6">
      <div className="flex items-center gap-4 mb-8">
        <span className="text-4xl">📱</span>
        <h1 className="text-3xl font-bold">Social Media Content</h1>
      </div>

      <div className="grid md:grid-cols-2 gap-8">
        <div>
          <img
            src="https://images.unsplash.com/photo-1611162616475-46b635cb6868?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1074&q=80"
            alt="Social Media Content"
            className="rounded-lg shadow-md w-full h-64 object-cover"
          />

          <div className="mt-6 bg-white p-6 rounded-lg shadow-sm border border-gray-100">
            <h2 className="text-xl font-semibold mb-4">Package Details</h2>
            <div className="space-y-4">
              <div className="flex justify-between">
                <span className="font-medium">Monthly Content</span>
                <span>15 posts</span>
              </div>
              <div className="flex justify-between">
                <span className="font-medium">Platforms</span>
                <div className="flex gap-2">
                  <FontAwesomeIcon
                    icon={faInstagram}
                    className="text-pink-600"
                  />
                  <FontAwesomeIcon
                    icon={faFacebook}
                    className="text-blue-600"
                  />
                  <FontAwesomeIcon icon={faTiktok} className="text-black" />
                </div>
              </div>
              <div className="flex justify-between">
                <span className="font-medium">Price</span>
                <span className="font-bold">10,000 MMK/month</span>
              </div>
            </div>

            <button className="mt-6 w-full bg-black text-white py-3 rounded-lg font-medium hover:bg-gray-800 transition">
              Subscribe Now
            </button>
          </div>
        </div>

        <div>
          <h2 className="text-2xl font-semibold mb-4">Features</h2>
          <div className="space-y-4">
            <div className="flex items-start gap-4">
              <FontAwesomeIcon icon={faImage} className="text-blue-500 mt-1" />
              <div>
                <h3 className="font-medium">High-Quality Visuals</h3>
                <p className="text-gray-600 text-sm">
                  Professionally designed graphics tailored for your brand
                </p>
              </div>
            </div>

            <div className="flex items-start gap-4">
              <FontAwesomeIcon
                icon={faCalendarAlt}
                className="text-green-500 mt-1"
              />
              <div>
                <h3 className="font-medium">Content Calendar</h3>
                <p className="text-gray-600 text-sm">
                  Scheduled posting for consistent online presence
                </p>
              </div>
            </div>

            <div className="flex items-start gap-4">
              <FontAwesomeIcon
                icon={faChartLine}
                className="text-purple-500 mt-1"
              />
              <div>
                <h3 className="font-medium">Performance Reports</h3>
                <p className="text-gray-600 text-sm">
                  Monthly analytics to track engagement growth
                </p>
              </div>
            </div>
          </div>

          <div className="mt-8">
            <h2 className="text-xl font-semibold mb-4">Sample Content</h2>
            <div className="grid grid-cols-2 gap-3">
              <img
                src="https://images.unsplash.com/photo-1611162616305-c69b3fa7fbe0?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1074&q=80"
                alt="Sample post 1"
                className="rounded-lg h-32 object-cover"
              />
              <img
                src="https://images.unsplash.com/photo-1611162617263-4ec3060a058e?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1074&q=80"
                alt="Sample post 2"
                className="rounded-lg h-32 object-cover"
              />
              <img
                src="https://images.unsplash.com/photo-1614680376573-df3480f0c6ff?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1074&q=80"
                alt="Sample post 3"
                className="rounded-lg h-32 object-cover"
              />
              <img
                src="https://images.unsplash.com/photo-1611162616475-46b635cb6868?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1074&q=80"
                alt="Sample post 4"
                className="rounded-lg h-32 object-cover"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SocialMediaPage;
